import API, { handleRequest } from "./lib/api";

const withParams = (params) => ({
  params: Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value !== undefined)
  ),
});

export const getGrandReport = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/grand-report", withParams(params))
  );

export const getOverviewReport = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/overview", withParams(params))
  );

export const printGrandReport = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/grand-report/print", withParams(params))
  );

export const getEndOfReport = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/end-of-report", withParams(params))
  );

export const printEndOfReport = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/end-of-report/print", withParams(params))
  );

export const getEndOfDayReportSummary = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/end-of-day-report", withParams(params))
  );

export const printEndOfDayReportSummary = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/end-of-day-report/print", withParams(params))
  );

export const getEndOfDayReportDetails = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/end-of-day-report/details", withParams(params))
  );

export const printEndOfDayReportDetails = (params) =>
  handleRequest(() =>
    API.get(
      "restaurant/reporting/end-of-day-report/details/print",
      withParams(params)
    )
  );

export const getEndOfDayReportServiceType = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/end-of-day-report/service-type", withParams(params))
  );

export const printEndOfDayReportServiceType = (params) =>
  handleRequest(() =>
    API.get(
      "restaurant/reporting/end-of-day-report/service-type/print",
      withParams(params)
    )
  );

export const getEndOfDayReportItemSales = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/item-sales", withParams(params))
  );

export const printEndOfDayReportItemSales = (params) =>
  handleRequest(() =>
    API.get("restaurant/reporting/item-sales/print", withParams(params))
  );

export const getReportSettings = (restaurantId) =>
  handleRequest(() => API.get(`restaurant/${restaurantId}/report-settings`));

export const updateReportSettings = (restaurantId, payload) =>
  handleRequest(() => API.put(`restaurant/${restaurantId}/report-settings`, payload));

export const updateEndOfDayReportAdjustment = (payload) =>
  handleRequest(() =>
    API.post("restaurant/reporting/end-of-day-report/adjustment", payload)
  );

export const createReportingOtp = (payload) =>
  handleRequest(() =>
    API.post("restaurant/otp/create", payload)
  );

export const verifyReportingOtp = (payload) =>
  handleRequest(() =>
    API.post("restaurant/otp/verify", payload)
  );

